import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import MetaHelmet from 'helpers/MetaHelmet';
import RegisterForm from './RegisterForm';
import ActivateForm from './ActivateForm';
import Welcome from './Welcome';
import SubmissionSuccess from './RegisterForm/SubmissionViews/SubmissionSuccess';
import SubmissionFail from './RegisterForm/SubmissionViews/SubmissionFail';
import IdentityVerification from './RegisterForm/SubmissionViews/IdentityVerification';
import IdentityVerificationFail from './RegisterForm/SubmissionViews/IdentityVerificationFail';
import ActivationSuccessful from './ActivateForm/ActivationSuccessful';

const ViewSwitch = ({ recaptchaKeys, bypassRecaptcha }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isAccount = searchParams.get('account') === 'true';

  if (isAccount) {
    return (
      <ActivateForm
        recaptchaKeys={recaptchaKeys}
        bypassRecaptcha={bypassRecaptcha}
      />
    );
  }

  return <Welcome />;
};

const Register = ({ v2Key, v3Key, bypassRecaptcha, initialUrl }) => (
  <BrowserRouter>
    <Routes>
      <Route
        path="/mycef/account/new"
        element={
          <>
            <MetaHelmet initialUrl={initialUrl} />
            <ViewSwitch
              recaptchaKeys={[v2Key, v3Key]}
              bypassRecaptcha={bypassRecaptcha}
            />
          </>
        }
      />
      <Route
        path="/mycef/account/new/*"
        element={
          <RegisterForm
            recaptchaKeys={[v2Key, v3Key]}
            bypassRecaptcha={bypassRecaptcha}
          />
        }
      />
      <Route
        path="/mycef/account/new/registration-success"
        element={<SubmissionSuccess />}
      />
      <Route
        path="/mycef/account/new/registration-unsuccessful"
        element={<SubmissionFail />}
      />
      <Route
        path="/mycef/account/new/identity-verification"
        element={<IdentityVerification />}
      />
      <Route
        path="/mycef/account/new/identity-verification-unsuccessful"
        element={<IdentityVerificationFail />}
      />

      <Route
        path="/mycef/account/new/activation-success"
        element={<ActivationSuccessful />}
      />
    </Routes>
  </BrowserRouter>
);

export default Register;
